<img alt="{{ phone().name || 'Telefon' }}" [src]="phone().mobilePhoneVariant?.image?.downloadUri" />
<span>
  <p class="card-title">{{ title() }}</p>
  <p>{{ phone().mobilePhoneVariant?.name }}</p>
</span>
<span class="price">
  {{ phone().mobilePhoneVariant?.bestMonthlyPriceWithMobilbytte | priceFormat: PriceType.Monthly }}
</span>
